import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIDataProvider, TApiResponse, AdminApiPaths } from '../../api';

const apiDataProvider = new APIDataProvider();

// eslint-disable-next-line import/prefer-default-export
export const generateQuestion = createAsyncThunk(
  'admin/gpt/question',
  async (data: any) => {
    const response = await apiDataProvider.post<TApiResponse<any>>(
      `${AdminApiPaths.gpt}/question`,
      data
    );

    return response.data;
  }
);
